import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from 'pages/common/ErrorPage/ErrorPage';
import { ProtectedRoute } from 'router/ProtectedRoute/ProtectedRoute';
import { AccessRoles } from 'shared/auth';
import MediaPlanning from 'pages/calculator/MediaPlanning/MediaPlanning';
import DigitalFairValue from 'pages/calculator/DigitalFairValue/DigitalFairValue';
import FairValue from 'pages/calculator/FairValue/FairValue';
import PrivacyPolicy from 'pages/PrivacyPolicy/PrivacyPolicy';
import Root from './routes/Root';
import Calculator from './routes/Calculator';
import routes from './routes';
import MediaPlansTable from '../pages/calculator/MediaPlanning/MediaPlansTable/MediaPlansTable';
import Plan from '../pages/calculator/MediaPlanning/Plan/Plan';
import { ErrorProvider } from '../pages/calculator/MediaPlanning/common/Errors/ErrorContext/ErrorContext';
import ComparedPlansPage from '../pages/calculator/MediaPlanning/ComparedPlansPage/ComparedPlansPage';
import AcceptedPlanPage from '../pages/calculator/MediaPlanning/AcceptedPlanPage/AcceptedPlanPage';

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <ErrorPage />,
    element: <Root />,
    children: [
      {
        path: 'media-planning/edit/:id',
        element: (
          <ProtectedRoute
            allowedRoles={[
              AccessRoles.FULL_ACCESS,
              AccessRoles.ONLINE_CAMPAIGNS,
            ]}
          >
            <ErrorProvider>
              <Plan />
            </ErrorProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: 'media-planning/compare',
        element: (
          <ProtectedRoute
            allowedRoles={[
              AccessRoles.FULL_ACCESS,
              AccessRoles.ONLINE_CAMPAIGNS,
            ]}
          >
            <ErrorProvider>
              <ComparedPlansPage />
            </ErrorProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: 'media-planning/accepted/:id',
        element: (
          <ProtectedRoute
            allowedRoles={[
              AccessRoles.FULL_ACCESS,
              AccessRoles.ONLINE_CAMPAIGNS,
            ]}
          >
            <ErrorProvider>
              <AcceptedPlanPage />
            </ErrorProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: '/',
        element: <Calculator />,
        children: [
          {
            path: routes.mediaPlanning,
            element: (
              <ProtectedRoute
                allowedRoles={[
                  AccessRoles.FULL_ACCESS,
                  AccessRoles.ONLINE_CAMPAIGNS,
                ]}
              >
                <ErrorProvider>
                  <MediaPlanning />
                </ErrorProvider>
              </ProtectedRoute>
            ),
            children: [
              {
                index: true,
                element: <MediaPlansTable />,
              },
            ],
          },
          {
            path: routes.fairValue,
            element: (
              <ProtectedRoute
                allowedRoles={[AccessRoles.FULL_ACCESS, AccessRoles.FAIR_VALUE]}
              >
                <FairValue />
              </ProtectedRoute>
            ),
          },
          {
            path: routes.digitalFairValue,
            element: (
              <ProtectedRoute
                allowedRoles={[AccessRoles.FULL_ACCESS, AccessRoles.FAIR_VALUE]}
              >
                <DigitalFairValue />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicy />,
  },
]);

export default router;
